import React, { Fragment, useContext } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import PurchaseOrdersGrid from './PurchaseOrdersGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import { commonFilter } from '../../constants/StyleConstants';
import usePurchaseOrdersPresenter from './PurchaseOrdersPresenter';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';

const useStyles = makeStyles(theme => {
  return {
    ...commonFilter,
  };
});

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const {
    selectedSupplier,
    setSelectedSupplier,
    purchaseOrderNumber,
    setPurchaseOrderNumber,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    validateAndSearch,
    cleanFilters,
  } = filtersProps;

  return (
    <div className={classes.filters}>
      {!isSupplier && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}
      <TextField
        margin="dense"
        id="razonSocial"
        style={{ width: 200 }}
        label="Nro. de pedido de compra"
        onChange={e => setPurchaseOrderNumber(e.target.value)}
        value={purchaseOrderNumber}
      />
      <CustomDatePicker value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const PurchaseOrders = ({ fullResponsive, onRowClick }) => {
  const { firstLoad, rows, loading, ...filtersProps } = usePurchaseOrdersPresenter();
  const { isSupplier } = useContext(LoginContext);

  return (
    <Fragment>
      <ViewPortGridWrapper fullResponsive={fullResponsive}>
        <Filters filtersProps={filtersProps} />
        <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
          <PurchaseOrdersGrid data={rows} onRowClick={onRowClick} loading={loading} />
        </DefaultUnrederedGridMessage>
      </ViewPortGridWrapper>
    </Fragment>
  );
};

export default PurchaseOrders;
